export { default } from "./GraficaVentasDia"
